import React from "react";
import Tracklist from "./Tracklist";
import './SearchResults.css';

function SearchResults(props) {
    return (
        <>
            <h2>Results</h2>
            <div>
                <Tracklist 
                    searchResults={props.searchResults} 
                    setPlaylist={props.setPlaylist}
                    getPreview={props.getPreview}
                />
            </div>
            
            {props.searchResults[0] ? <p style={{color: "red"}}><i>End of List</i></p> : null} 
        </>
        
    );
}

export default SearchResults;